import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let DetailAddress = class DetailAddress extends Vue {
    constructor() {
        super(...arguments);
        this.receiver = {};
    }
    get address() {
        return (this.receiver.receiver_address ||
            `${this.receiver.province_name}${this.receiver.city_name}${this.receiver
                .district_name || ''}${this.receiver.address}`);
    }
    created() {
        this.showAddress();
    }
    toAddressList() {
        if (!this.canChange)
            return;
        let { tid, receiver_id } = this.$route.query;
        const _head = location.origin;
        let _redirect = `${window.location.origin}${window.location.pathname}?tid=${tid}`;
        window.location.replace(`${_head}/center/address/addressList?mode=select${receiver_id ? '&receiverId=' + receiver_id : ''}&redirect=` + encodeURIComponent(_redirect));
    }
    async showAddress() {
        if (this.express &&
            this.express.receiver_name &&
            this.express.phone &&
            this.express.receiver_address) {
            this.receiver = {
                name: this.express.receiver_name,
                phone: this.express.phone,
                receiver_address: this.express.receiver_address,
            };
            return;
        }
        let { receiver_id } = this.$route.query;
        let { data } = await this.$axios.post(`/api/mobile/course/yaya/getUserReceiver`);
        let checkAddress = data.find(item => {
            if (receiver_id) {
                return item.id === +receiver_id;
            }
            else {
                return item.is_default;
            }
        });
        if (checkAddress) {
            this.receiver = checkAddress;
            this.$emit('update:receiverChange', checkAddress);
        }
    }
};
tslib_1.__decorate([
    Prop()
], DetailAddress.prototype, "express", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], DetailAddress.prototype, "canChange", void 0);
DetailAddress = tslib_1.__decorate([
    Component
], DetailAddress);
export default DetailAddress;
